import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from "./api";
import '@/assets/style/washou.css'
import '@/assets/style/font/iconfont.css'
Vue.config.productionTip = false
import * as echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { eventBus } from './utils/bus';
Vue.use(ElementUI);
Vue.use(echarts);
Vue.prototype.$echarts = echarts;
Vue.prototype.$API = api;
Vue.prototype.$Bus = eventBus;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
